import React, {useEffect, useState} from 'react';
import HeaderButton from 'shared/components/layout/HeaderButton';
import {ServiceId} from 'shared/models/RouterParam';
import {useSelector} from 'react-redux';
import {AppState} from 'shared/store';
import IrrigationIcon from './icons/IrrigationIcon';
import useServiceSelected from 'shared/hooks/useServiceSelected';
import navigationService from 'shared/services/NavigationService';
import {DEFAULT_IRRIGATION_VUE} from '../configs/IrrigationRoutePaths';
import useCurrentCampaign from 'modules/campaigns/hook/useCurrentCampaign';

interface IrrigationHeaderButtonProps {
  alwaysShowTitle?: boolean;
}
const IrrigationHeaderButton: React.FC<IrrigationHeaderButtonProps> = (
  props,
) => {
  const selected = useServiceSelected(ServiceId.IRRIGATION);
  const currentCampaign = useCurrentCampaign()

  const [path, setPath] = useState<string>('');
  const {selectedFieldId, selectedCampaign} = useSelector<
    AppState,
    AppState['fields']
  >(({fields}) => fields);

  useEffect(() => {
    let campaignId: number | null = null

    if (selectedCampaign) {
      campaignId = selectedCampaign
    } else {
      campaignId = currentCampaign
    }

      const firstPath = navigationService.getFirstServiceUrl(
        campaignId,
        selectedFieldId,
        ServiceId.IRRIGATION,
        DEFAULT_IRRIGATION_VUE,
      );
      setPath(firstPath);
  }, [selectedFieldId, selectedCampaign, currentCampaign]);

  return (
    <>
      <HeaderButton
        path={path}
        titleId='irrigation.headerButton.title'
        icon={<IrrigationIcon selected={selected} />}
        alwaysShowTitle={props.alwaysShowTitle}
        selected={selected}
        serviceId={ServiceId.IRRIGATION}
      />
    </>
  );
};

export default IrrigationHeaderButton;
